import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { imageLocation } from '../config/constants';
import '../style/firm.css';

export class Firm extends Component {
	componentWillMount() {
		document.title = 'Firm';
	}

	render() {
		return (
			<div className="firm">
				<div className="docs">
					<a rel="noopener noreferrer" target="_blank" href="../resume.pdf">
						Resume
					</a>
					<br />
					<a rel="noopener noreferrer" target="_blank" href="../publications.pdf">
						Publications
					</a>
				</div>
				<div className="text">
					<Grid container direction="row">
						<Grid item xs={6}>
							<p style={{ textAlign: 'justify', marginRight: '20px' }}>
								{this.props.data.firm.description}
							</p>
							<p style={{ textAlign: 'justify', marginRight: '20px' }}>
								{this.props.data.firm.description2}
							</p>
						</Grid>
						<Grid item xs={4}>
							<img
								src={`${imageLocation}firm.jpg`}
								alt="ecobb firm"
								style={{ width: '100%', maxHeight: 'calc(100vh - 100px)' }}
							/>
						</Grid>
					</Grid>
				</div>
			</div>
		);
	}
}

export class MobileFirm extends Firm {
	render() {
		return (
			<div className="mobileFirm">
				<Grid container direction="row">
					<Grid item xs={8}>
						<p style={{ textAlign: 'justify', margin: '10px' }}>{this.props.data.firm.description}</p>
						<p style={{ textAlign: 'justify', margin: '10px' }}>{this.props.data.firm.description2}</p>
					</Grid>
					<Grid item xs={4}>
						<img
							src={`${imageLocation}firm.jpg`}
							alt=""
							style={{ position: 'fixed', width: '33%', maxHeight: 'calc(100vh - 100px)' }}
						/>
					</Grid>
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/firm.js